/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonIconOutline/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonIconOutline({
  children,
  viewPath = "/DesignSystem/ButtonIconOutline",
  onMouseEnter,
  onMouseLeave,
  onClick,
  marginTop = 0,
  marginRight = 0,
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 5,
  borderBottomRightRadius = 5,
  borderColor = "#e6e6e6",
  borderTopLeftRadius = 5,
  borderTopRightRadius = 5,
  isDisabled,
  width = "auto",
  height = "auto",
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave,isDisabled})
  return (<React.Fragment
>
<button
  data-testid="ButtonIconOutline.Vertical"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 {...isHoveredBind}
 onClick={onClick}
 disabled={isDisabled}
 style={{'--mt-1-Z1JNvUr': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-2-Z1JNvUr': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--as-3-Z1JNvUr': alignSelf,'--bblr-5-Z1JNvUr': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-6-Z1JNvUr': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-8-Z1JNvUr': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-9-Z1JNvUr': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--w-10-Z1JNvUr': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1JNvUr': typeof height === 'number' ? `${height}px` : height,'--bc-4-Z1JNvUr': isHovered ? "rgba(0,162,255, 0.15)" : backgroundColor,'--bc-7-Z1JNvUr': isHovered ? "rgba(0,162,255, 0.0)" : borderColor}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</button>
</React.Fragment>)
}